import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { ExternalLink, ArrowLeft, BookOpen, Hash, Layers, Calendar as CalIcon, Sparkles } from "lucide-react";

export default function BookDetail() {
  const { slug } = useParams();
  const [book, setBook] = useState(null);
  const [notFound, setNotFound] = useState(false);
  useEffect(() => {
    api.get(`/books/by-slug/${slug}`).then((r) => setBook(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) return (
    <div className="max-w-3xl mx-auto px-6 py-32 text-center">
      <h1 className="font-serif text-4xl mb-4">Livro não encontrado</h1>
      <Link to="/livraria" className="btn-outline-gold text-sm border-[color:var(--marupiara-gold-dark)] text-[color:var(--marupiara-gold-dark)]">Voltar à livraria</Link>
    </div>
  );
  if (!book) return <div className="py-32 text-center">Carregando…</div>;

  return (
    <div className="bg-[color:var(--marupiara-ivory)]">
      <section className="py-16 bg-[color:var(--marupiara-obsidian)] text-white">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-10">
          <Link to="/livraria" className="inline-flex items-center gap-2 text-sm text-[color:var(--marupiara-gold)] mb-8"><ArrowLeft size={14} /> Voltar à livraria</Link>
          <div className="grid md:grid-cols-2 gap-12 items-start">
            <div className="max-w-md">
              <div className="aspect-[2/3] overflow-hidden bg-neutral-800">
                <img src={book.cover_url} alt={book.title} className="w-full h-full object-cover" />
              </div>
            </div>
            <div>
              <div className="overline text-[color:var(--marupiara-gold)] mb-3">{book.category}</div>
              <h1 className="font-serif text-4xl sm:text-5xl leading-tight mb-3">{book.title}</h1>
              {book.subtitle && <p className="font-serif italic text-2xl text-white/70 mb-6">{book.subtitle}</p>}
              <p className="text-lg text-[color:var(--marupiara-gold-light)] mb-6">por {book.author_name}</p>
              <p className="text-white/80 leading-relaxed mb-8">{book.synopsis}</p>
              <div className="grid grid-cols-2 gap-3 mb-8 text-sm">
                {book.isbn && <div className="flex gap-2 text-white/70"><Hash size={16} className="text-[color:var(--marupiara-gold)]" /> ISBN {book.isbn}</div>}
                {book.pages && <div className="flex gap-2 text-white/70"><BookOpen size={16} className="text-[color:var(--marupiara-gold)]" /> {book.pages} páginas</div>}
                {book.format && <div className="flex gap-2 text-white/70"><Layers size={16} className="text-[color:var(--marupiara-gold)]" /> {book.format}</div>}
                {book.year && <div className="flex gap-2 text-white/70"><CalIcon size={16} className="text-[color:var(--marupiara-gold)]" /> {book.year}</div>}
              </div>
              {book.price && <div className="font-serif text-3xl text-[color:var(--marupiara-gold)] mb-6">{book.price}</div>}
              {book.status === "coming_soon" ? (
                <div data-testid="book-detail-coming-soon" className="inline-flex items-center gap-2 px-6 py-3 border border-[color:var(--marupiara-gold)] bg-[color:var(--marupiara-gold)]/10 text-[color:var(--marupiara-gold-light)] uppercase tracking-widest font-semibold">
                  <Sparkles size={16} /> Em Breve
                </div>
              ) : book.buy_link ? (
                <a href={book.buy_link} target="_blank" rel="noreferrer" data-testid="book-detail-buy" className="btn-gold">Comprar agora <ExternalLink size={16} /></a>
              ) : null}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
